import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { failureToast } from '../../../../support/utils';
import { DetailRow, yesNo } from '../../components/DetailRow';
import {
  defaultCompanyChange,
  ICompanyChange,
} from '../../models/CompanyChange';
import { viewCompanyChange } from '../../redux/CompanyChangesCRUD';

export const ViewCompanyChange = () => {
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ICompanyChange>(defaultCompanyChange);

  const handleFetch = async (id: string) => {
    setLoading(true);
    try {
      const result = await viewCompanyChange(id);
      setData(result);
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      handleFetch(id);
    }
  }, [id]);

  return (
    <div className={`card ${loading ? 'overlay overlay-block' : ''}`}>
      <div className="card-header">
        <h3 className="card-title">Company Change</h3>
      </div>

      <div className={`card-body py-10 ${loading ? 'overlay-wrapper' : ''}`}>
        <div className="mw-800px mx-auto">
          <h4 className="fw-bolder mb-6">Contact</h4>
          <DetailRow label="Name" value={data.name} />
          <DetailRow label="Email" value={data.email} />
          <DetailRow label="Customer number" value={data.customer_number} />
          <DetailRow label="Phone" value={data.phone} />

          <div className="separator my-8"></div>
          <h4 className="fw-bolder mb-6">Old company details</h4>
          <DetailRow label="Old company name" value={data.old_company_name} />
          <DetailRow label="Address" value={data.old_address} />
          <DetailRow label="Postal code" value={data.old_postal_code} />
          <DetailRow label="City" value={data.old_city} />

          <div className="separator my-8"></div>
          <h4 className="fw-bolder mb-6">New company details</h4>
          <DetailRow label="New company name" value={data.new_company_name} />
          <DetailRow label="KVK" value={data.new_kvk} />
          <DetailRow label="Address" value={data.new_address} />
          <DetailRow label="House number" value={data.new_house_number} />
          <DetailRow label="Postal code" value={data.new_postal_code} />
          <DetailRow label="City" value={data.new_city} />
          <DetailRow
            label="New company email"
            value={data.new_company_email}
          />
          <DetailRow label="Change effective date" value={data.change_date} />

          <div className="separator my-8"></div>
          <DetailRow
            label="Treat as takeover"
            value={yesNo(data.is_company_takeover)}
          />
          <DetailRow label="Agreed" value={yesNo(data.terms_accepted)} />
          <DetailRow label="Submitted at" value={data.created_at} />

          <div className="row pt-5">
            <div className="col-lg-12">
              <Link
                className="btn btn-color-gray-600 btn-active-light-primary fw-bolder px-6 py-3"
                to="/form-management/company-changes"
              >
                Back
              </Link>
            </div>
          </div>
        </div>

        {loading && (
          <div className="overlay-layer rounded bg-dark bg-opacity-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
